export default {
  errorMsg: {
    onlyCancelBookingInReservedStatus: 'Không thể hủy đặt phòng đã được ở',
    roomIsInBooking: 'Phòng đang được đặt',
    passwordIsNotCorrect: 'Mật khẩu không chính xác',
    chooseAnotherRoom: 'Vui lòng chọn phòng khác',
    loginFailure: 'Đăng nhập thất bại',
    breakfastCodeUsed: 'Mã ăn sáng đã được sử dụng',
    roomSurchargeUsed: 'Không thể xóa phụ thu phòng đã được sử dụng',
    pleaseChangeRoomMaster: 'Vui lòng đổi phòng Master',
    onlyOneCommissionFee: 'Chỉ được chọn một hình thức phí hoa hồng',
    idIsNotExist: 'ID không tồn tại',
    marketSegIsInUse: 'Phân khúc thị trường đã được sử dụng không thể xóa',
    cannotNotCheckInForBookingNotInBookedStatus:
      'Không thể Check-in cho đặt phòng có trạng thái khác đã đặt',
    used: 'Dịch vụ đã được sử dụng không thể sửa',
    priceCodeIsInUse: 'Mã giá đã được sử dụng không thể xóa',
    subBookingGroupsMustNotNull: 'Đoàn phụ bắt buộc phải nhập',
    pleaseCompletePaymentForTransactions:
      'Một số phòng còn giao dịch nợ tiền, không thể checkout',
    cannotDecreaseNumOfGuest: 'Chỉ được thêm số lượng khách',
    invalidDepartDate: 'Thời gian đi không được sớm hơn thời gian đến',
    discountPercentMax100: 'Phần trăm giảm giá không được lớn hơn 100%',
    discountAmountMax: 'Số tiền giảm giá không được lớn hơn giá phòng',
    discountReasonMaxLength50: 'Lý do giảm giá không được quá 50 ký tự',
    taxAndFeeCannotBeLeftBlankWhenSelectingManualEntry:
      'Thuế và phí bắt buộc phải nhập khi chọn nhập mức thuế, phí thủ công',
    cannotCombineGroupForBookingHaveAnyTransaction:
      'Không thể ghép nhóm đã có thanh toán',
    invalidBooking: 'Đặt phòng không hợp lệ',
    changeRoomReasonNotNull: 'Trường lý do chuyển phòng không được để trống',
    customerNotFound: 'Không tìm thấy khách hàng',
    lastNameNotNull: 'Trường họ không được để trống',
    mustHaveOneMasterRoom: 'Cần có đặt phòng master',
    firstNameNotNull: 'Trường tên không được để trống',
    mustHaveAtLeastOneBookingRoom: 'Cần đặt ít nhất 01 phòng',
    currencyNotNull: 'Trường tiền tệ không được để trống',
    authentication: 'Bạn đã bị đăng xuất, vui lòng đăng nhập lại',
    default: 'Đã có lỗi xảy ra',
    codeExist: 'Mã đã tồn tại',
    cannotDeleteCurrencyIsUsed: 'Không thể xóa loại tiền tệ này',
    inputDataInvalid: 'Thông tin nhập vào không chính xác',
    roomIsOccupied: 'Phòng đã bị chiếm',
    selectRow: 'Vui lòng chọn một hàng để thực thi',
    selectTransactionRow: 'Vui lòng chọn một loại giao dịch thực thi',
    authorization: 'Bạn không có quyền truy cập vào chức năng này',
    downloadError: 'Tải file thất bại, vui lòng thử lại sau',
    taxCodeExist: 'Mã đã tồn tại',
    updateError: 'Cập nhật thất bại, thử lại sau',
    passengerClassCodeMustBeNumeric: 'Mã hạng khách sai định dạng',
    passengerClassCodeMustBeLessThan100: 'Mã khách bắt buộc nhỏ hơn 100',
    codeAlreadyExists: 'Mã đã tồn tại',
    marketSegGroupHasBeenAssignedToTheMarketSeg:
      'Không thể xóa phân khúc thị trường này',
    sourceAlreadyExist: 'Mã đã tồn tại',
    cannotDeletedBuildingBecauseItHasRooms:
      'Không thể xóa tòa nhà đang có phòng',
    roomPropertyHasBeenUsed: 'Không thể xóa thuộc tính phòng đang được sử dụng',
    roomLevelHasBeenUsed: 'Không thể xóa hạng phòng đang được sử dụng',
    cannotDeleteRoomsWithInterconnectedData:
      'Không thể xóa phòng đang kết nối dữ liệu',
    theSourceGroupCannotBeDeletedBecauseItIsAlreadyAssignedToTheSource:
      'Không thể xóa nguồn đang được sử dụng',
    nameLengthMustBeLessThan50Character:
      'Độ dài của trường mô tả không vượt quá 50 kí tự',
    cannotDeleteMainCategory: 'Không thể xóa danh mục có danh mục con',
    productAttributeCodeExist: 'Mã đã tồn tại',
    categoryAttributeCodeAlreadyExists: 'Mã đã tồn tại',
    transactionCodeAlreadyExist: 'Mã giao dịch đã tồn tại',
    invalidTax: 'Mã thuế không đúng',
    subTransactionCodeAlreadyExist: 'Mã giao dịch phụ đã tồn tại',
    codeAlreadyExist: 'Mã đã tồn tại',
    selectConfiguration: 'Vui lòng chọn cấu hình',
    selectOneConfigurationOnly: 'Vui lòng chỉ chọn một cấu hình',
    timeFrameStartMustBeforeEnd:
      'Khung giờ kết thúc phải muộn hơn khung giờ bắt đầu',
    codeAlreadyExistOrNoshowDoesNotExist: 'Mã đã tồn tại',
    subTransactionDoesNotExist: 'Mã giao dịch không tồn tại',
    selectPackageCategory: 'Vui lòng chọn một danh mục gói',
    createPackageCategoryFailure: 'Tạo danh mục gói không thành công',
    packageCategoryCodeExist: 'Mã danh mục đã tồn tại',
    updatePackageCategoryFailure: 'Cập nhật danh mục gói không thành công',
    deletePackageCategoryFailure: 'Xóa danh mục gói không thành công',
    packageIsInUseCannotBeDeleted:
      'Danh mục gói đang được sử dụng, không thể xóa',
    selectPackage: 'Vui lòng chọn gói',
    selectPackageDetail: 'Vui lòng chọn chi tiết gói',
    selectOnePackageOnly: 'Vui lòng chỉ chọn một gói',
    selectOnePackageDetailOnly: 'Vui lòng chỉ chọn một chi tiết gói',
    packageDoesNotExist: 'Gói không tồn tại',
    breakfastCodeAlreadyExisted: 'Mã ăn sáng đã tồn tại',
    adultPriceMustBeGreaterThanOrEqualTo0:
      'Giá người lớn phải lớn hơn hoặc bằng 0',
    childPriceMustBeGreaterThanOrEqualTo0:
      'Giá trẻ em phải lớn hơn hoặc bằng 0',
    earlyLateCheckCodeExist: 'Mã đã tồn tại',
    createEarlyLateCheckFailure: 'Thêm cấu hình thất bại',
    updateEarlyLateCheckFailure: 'Cập nhật cấu hình thất bại',
    saleStartDateMustBeforeEnd: 'Ngày bắt đầu bán phải trước ngày kết thúc bán',
    minApplyPeopleAndMaxApplyPeopleMustBeFilledInTogetherOrLeftBlank:
      'Số lượng người áp dụng tối thiểu và tối đa phải cùng được điền hoặc bỏ trống',
    minApplyPeopleMustBeLessThanOrEqualToMaxApplyPeople:
      'Số lượng người áp dụng tối thiểu không được lớn hơn tối đa',
    minApplyNightAndMaxApplyNightMustBeFilledInTogetherOrLeftBlank:
      'Số lượng đêm áp dụng tối thiểu và tối đa phải cùng được điền hoặc bỏ trống',
    minApplyNightMustBeLessThanOrEqualToMaxApplyNight:
      'Số lượng đêm áp dụng tối thiểu không được lớn hơn tối đa',
    fromDateMustEarlierThanToDate: 'Từ ngày không được lớn hơn đến ngày',
    selectPriceCategory: 'Vui lòng chọn danh mục giá',
    selectPriceCode: 'Vui lòng chọn mã giá',
    priceCodeAlreadyExist: 'Mã giá đã tồn tại',

    stageCodeIsDuplicated: 'Mã giai đoạn không được trùng lặp',
    periodCannotOverlap:
      'Khoảng thời gian giữa các mã giai đoạn không được trùng lặp',
    duplicatedPeriod: 'Khoảng thời gian đã bị trùng',
    selectPriceTypeError: 'Hãy chọn loại giá',
    cannotDeleteTransactionIsUsing:
      'Không thể xóa mã giao dịch đang được sử dụng',
    cannotDepartmentCurrencyIsUsed: 'Bộ phận đang được sử dụng, không thể xóa',
    userGroupNameExisted: 'Tên nhóm người dùng đã tồn tại',
    userGroupAlreadyUsed: 'đang được sử dụng, không thể xóa',
    nameExist: 'Tên đã tồn tại',
    serviceTypeIdDoesNotExit: 'Loại dịch vụ không hợp lệ',
    selectRoomServiceGroup: 'Vui lòng chọn nhóm dịch vụ buồng phòng',
    mustSavePriceCodeBeforeEditingPriceByLevel:
      'Bạn phải lưu mã giá trước khi chỉnh sửa giai đoạn',
    selectBreakfastCode: 'Bạn chưa chọn mã ăn sáng',
    enterTransactionInformation: 'Vui lòng điền đủ thông tin giao dịch',
    subTransactionMustNotOverlapping: 'Giao dịch phụ không được trùng nhau',
    totalPercentageMustEqual100: 'Tổng phần trăm ghi nhận phải bằng 100%',
    selectService: 'Vui lòng chọn dịch vụ',
    createSpecialFail: 'Thêm dịch vụ thất bại',
    updateFail: 'Cập nhật thất bại',
    deleteFail: 'Xóa thất bại',
    specialServiceCodeExist: 'Mã dịch vụ đặc biệt đã tồn tại',
    statusCannotBeChangedWhenRequestDateIsLessThanNow:
      'Không thể thay đổi đơn vị có ngày nhỏ hơn hiện tại',
    theStartDateMustBeEarlierOrTheSameAsTheEndDate:
      'Thời gian kết thúc phải bằng hoặc sau thời gian bắt đầu',
    selectRoomSurcharge: 'Vui lòng chọn phụ thu phòng',
    theMoneyMustBeGreaterThanOrEqualTo0: 'Số tiền phải lớn hơn hoặc bằng 0',
    recordPercentageMustInRangeOf0And100:
      'Phần trăm ghi nhận phải trong khoảng 0 - 100%',
    fillSubGroup: 'Vui lòng xem lại các trường trong Đoàn phụ',
    deleteCodeFailure: 'Không xóa được mã đang được sử dụng',
    deleteAttributeCategoryFailure:
      'Không thể xóa danh mục thuộc tính đang được sử dụng',
    usernameOrIdCardAlreadyExisted:
      'ID nhân viên hoặc tên đăng nhập đã tồn tại',
    deleteAccountFailure: 'Không thể xóa tài khoản ADMIN',
    usernameAlreadyExisted: 'Tên đăng nhập đã tồn tại',
    idCardAlreadyExisted: 'ID Nhân viên đã tồn tại',
    phoneNumberAlreadyExisted: 'Số điện thoại đã tồn tại',
    emailAlreadyExisted: 'Email đã tồn tại',
    selectCustomerRow: 'Cần chọn một khách để thực hiện thao tác',
    surplusError: 'Phòng còn giao dịch nợ tiền, không thể checkout',
    cannotDeleteSubTransactionIsUsing:
      'Không thể xóa mã GD phụ đang được sử dụng',
    someSubTransactionExistsThatCannotBeDeleted:
      'Tồn tại giao dịch phụ không thể xóa',
    someServiceExistsThatCannotBeDeleted:
      'Tồn tại dịch vụ buồng phòng không thể xóa',
    addRoomChargeSuccess: 'Thêm thành công',
    selectPackGroup: 'Vui lòng chọn nhóm gói!',
    selectOnlyOnePackGroup: 'Vui lòng chỉ chọn một nhóm gói!',
    packageGroupBeingUsed: 'Nhóm gói đang được sử dụng',
    saveProductFail: 'Lưu thất bại',
    invalidTransaction: 'Loại giao dịch không hợp lệ',
    invalidSubTransactionType: 'Loại giao dịch phụ không hợp lệ',
    specialServiceInUse: 'Dịch vụ đặc biệt đang được sử dụng',
    selectPromotion: 'Vui lòng chọn khuyến mại',
    selectOneselectPromotionOnly: 'Vui lòng chỉ chọn một khuyến mại',
    theNumberOfRoomsExceedsTheNumberOfRoomsOfTheCreatedRoomLevel:
      'Hạng phòng đã đủ số phòng tối đa',
    duplicateAssignOt: 'Thời gian làm thêm giờ bị trùng lặp',
    timeError: 'Thời gian bắt đầu cần nhỏ hơn thời gian kết thúc',
    roomPropertyCodeAlreadyExist: 'Mã thuộc tính đã tồn tại',
    sourceGroupAlreadyExist: 'Mã đã tồn tại',
    marketSegAlreadyExist: 'Mã đã tồn tại',
    cannotDeleteDebitAccountIsInUse:
      'Không thể xóa tài khoản công nợ đang được sử dụng',
    roomOccupied: 'Phòng đã được chiếm',
    'roomCreatedOOO/OOS': 'Trạng thái phòng đang là OOO/OOS',
    addFailure: 'Thêm không thành công',
    errorWhenDelete: 'Xóa không thành công',
    startTimeMustEarlierThanEndTime:
      'Thời gian kết thúc không được trước thời gian bắt đầu',
    hotelAlreadyHaveBfCode: 'Khách sạn đã có mã ăn sáng',
    // stringInputOnlyContainsLettersNumbersAndUnderscore:
    //   'Mã hạng phòng bắt buộc là chữ, số, dấu gạch ngang, dấu gạch dưới.',
    roomNumberAlreadyExist: ' Số phòng đã tồn tại',
    canNotChangeTheStatus: 'Không thể cập nhật trạng thái',
    idDoesNotExist: 'ID không tồn tại',
    userIdDoesNotPermission: 'Tài khoản không có quyền',
    userIdDoesNotExist: 'Tài khoản không tồn tại',
    userNotCashier: 'Tài khoản không phải là thu ngân',
    accountAuthenticationIsIncorrect: 'Thông tin tài khoản không hợp lệ',
    uploadNotSuccess: 'Tải lên không thành công, vui lòng kiểm tra lại',
    productCodeAlreadyExisted: 'Mã sản phẩm đã tồn tại',
    cannotChooseThisRoom: 'Không thể lựa chọn phòng này',
    materialCannotBeDupplicated: 'Giá trị lựa chọn không thể trùng lặp',
    agencyNotSelected: 'Vui lòng chọn công ty/đại lý du lịch ở mục Đặt phòng.',
    invoiceInfoMissing:
      'Vui lòng điền đầy đủ thông tin Tên công ty, Mã số thuế và Địa chỉ',
    taxCodeIsExist: 'Trùng mã số thuế',
    notEnoughNumOfRoom: 'Không đủ số lượng phòng',
    sourceNotNull: 'Trường nguồn là bắt buộc',
    materialCannotBeDuplicated: 'Giá trị khai báo lựa chọn không thể trùng lặp',
    roomSurchargeCodeExisted: 'Mã phụ thu phòng đã tồn tại',
    roomServiceGroupDoesNotExist: 'Nhóm dịch vụ buồng phòng không tồn tại',
    cannotCheckInForRoomNotVCI: 'Không thể check-in cho phòng không phải VCI',
    haveNotAssignRoom: 'Chưa gán phòng',
    createChildBookingGroupSuccessfully: 'Tạo đoàn phụ thành công',
    bookingNotAssignedRoomYet: 'Chưa gán phòng',
    productsBelongingToTheFinishedProductsOrServicesCategoryAreNotSelectedAsQuickPurchaseProducts:
      'sản phẩm thuộc danh mục sản phẩm hoàn thiện hoặc dịch vụ không được chọn là sản phẩm mua hàng nhanh',
    theDataDoesNotMatchTheSavedData: 'dữ liệu không khớp với dữ liệu đã lưu',
    productTypesCanOnlyBeEnteredWithNumbersFrom1To5:
      'loại sản phẩm chỉ có thể được nhập bằng số từ 1 đến 5',
    fileExcelWrongData: 'Sai dữ liệu trong file Excel',
    thisCategoryAttributeAlreadyUsed: 'Danh mục thuộc tính đã được sử dụng',
    filesNotAllowedToOver20Mb: 'File không được vượt quá 5Mb',
    insertFailure: 'Thêm không thành công, kiểm tra lại các trường thông tin',
    cancelApplyFailure: 'Không thể thực hiện thao tác',
    quantitiesCanNotEmpty: 'Vui lòng chọn số lượng cho sản phẩm',
    debtAccountCannotPayThisInvoice:
      'Số thanh toán nhập vào lớn hơn số dư công nợ',
    hotelIdAlreadyExist: 'ID Khách sạn đã tồn tại',
    thisAccountIsLocked: 'Tài khoản đã bị khóa',
    newPasswordIsEqualPassword: 'Mật khẩu đã nhập trùng với mật khẩu cũ',
    wrongPatternPassword: 'Mật khẩu sai định dạng',
    routingAlreadyExisted: 'Routing đã tồn tại',
    subTransactionNameAlreadyExist: 'Mã giao dịch phụ đã tồn tại',
    invalidEmail: 'Email không hợp lệ',
    theTotalNumberOfRoomsMustBeLessThan999: 'Số phòng tối đa là 999',
    theTotalNumberOfRoomsMustBeGreatThan0: 'Số phòng tối thiểu là 1',
    theSourceGroupCannotUpdateTheSourceGroupItself:
      'Nhóm nguồn không thể cập nhật nhóm nguồn là chính nó',
    theMarketSegGroupCannotUpdateTheMarketSegGroupItself:
      'Nhóm PKTT không thể cập nhật nhóm PKTT là chính nó',
    StartDateMustBeforeEnd: 'Ngày bắt đầu phải trước ngày hết hạn',
    bankAccountBeingUsed: 'Không thể xóa tài khoản đang được sử dụng',
    finishProductCodeDoesNotAlready: 'không tồn tại',
    materialCodeDoesNotAlready: 'không tồn tại',
    someRoomAlreadyCheckedOut:
      'Phòng đã được Check-out, kiểm tra lại thông tin',
    checkoutFailure: 'Trả phòng thất bại',
    dateToMustBeGreaterThanDateFrom: 'Ngày kết thúc phải lớn hơn ngày yêu cầu',
    roomWasCreatedOooOos: 'Phòng đã được tạo OOO/OOS',
    maintenanceWorkIsNotANewRequestStatusCannotBeUpdate:
      'Công việc bảo trì không phải là trạng thái yêu cầu mới',
    addFail: 'Thêm thất bại',
    refuseFail: 'Từ chối thất bại',
    receiveFail: 'Tiếp nhận thất bại',
    codeAlreadyExisted: 'ID đã tồn tại',
    theAmountDoesNotExceedOneBillion: 'Số  tiền tối đa là 1.000.000.000',
    stringInputOnlyContainsLettersNumbersAndUnderscore:
      'Mã bắt buộc là chữ, số, dấu gạch ngang, dấu gạch dưới.',
    statusCannotBeChangedWhenRequireStatusIsFinish:
      'Không thể thay đổi trạng thái khi yêu cầu đã hoàn thành',
    refundFailure: 'Hoàn tiền thất bại',
    usernameAndPasswordDoesNotMatch:
      'Thông tin tài khoản và mật khẩu không hợp lệ',
    cannotDeleteTravellerHasHadBooking:
      'Không thể xóa khách đã phát sinh dữ liệu',
    invalidPhoneNumber: 'Số điện thoại không hợp lệ',
    transferFailure: 'Chuyển giao dịch thất bại',
    cannotDeleteSubBookingGroup: 'Không thể xóa đoàn phụ',
    fileSizeExceeds1MB: 'Dung lượng File quá lớn (>1Mb)',
    paymentFailure: 'Thanh toán thất bại',
    checkAgain: 'Vui lòng kiểm tra lại dữ liệu',

    // datnt
    emailMustNotNull: 'Không nhập Email',
    phone1MustNotNull: 'Không nhập số điện thoại',
    // taxCodeIsExist: 'Mã số thuế đã tồn tại'
    exceed5ProfileToMerge: 'Chỉ có thể gộp tối đa 5 hồ sơ một lần',
    contactNameMustNotNull: 'Tên liên hệ là bắt buộc',
    roomInUsed: 'Phòng đã được sử dụng',
    priceNoteMaxLength50: 'Ghi chú có tối đa 50 kí tự',
    agentIdIsRequired: 'Chọn trước 1 đại lý để xem chi tiết',
    sourceMustNotNull: 'Nguồn bắt buộc chọn',
    amountMoneyGreatThanZero: 'Nhập số tiền lớn hơn 0',
    productIsInUse: 'Sản phẩm đang được sử dụng',
    productAttributeIsInUse: 'Thuộc tính đã được sử dụng',
    productAttributeCategoryIsInUse: 'Danh mục thuộc tính đã được sử dụng',
    productCalUnitIsInUse: 'Đơn vị tính đã được sử dụng',
    productPortFolioIsInUse: 'Danh mục sản phẩm đã được sử dụng',
    accountIDDoesNotExist: 'Tài khoản không tồn tại',
    cannotDeleteRoomHavingTransaction: 'Không thể xóa đoàn phụ đã có giao dịch',
    cannotCancelGroupHavingRoomInHouse: 'Không thể hủy đoàn đã có phòng đang ở',
    chooseAnotherBooking: 'Không thể tách nhóm với đặt phòng này',
    cannotDeleteInUseCode: 'Không thể  xóa mã lý do đã sử dụng',
    existCode: 'Mã đã tồn tại',
    timeInvalid: 'Thời gian không hợp lệ'
  },
  successMsg: {
    deletedRoomSuccess: 'Xóa phòng thành công',
    separateGroupSuccess: 'Đã tách phòng thành công',
    cancelBookingSuccess: 'Hủy phòng thành công',
    cancelBookingSuccessfully: 'Hủy phòng thành công',
    changeRoomSuccessfully: 'Đổi phòng thành công',
    extendBookingSuccessfully: 'Gia hạn thành công',
    updateSuccessfully: 'Cập nhật thành công',
    checkInSuccessFully: 'Check-in thành công',
    deleteDataSuccessfully: 'Xóa thành công',
    createBookingGroupSuccess: 'Tạo đoàn thành công',
    default: 'Thành công',
    deletedRoomPropertySuccess: 'Xóa thành công',
    combineGroupSuccess: 'Ghép phòng thành công',
    assignRoomSuccessfully: 'Gán phòng thành công',
    createInvoiceCompanySuccessfully:
      'Lưu thông tin công ty xuất hóa đơn thành công',
    updateBookingSuccess: 'Cập nhật đặt phòng thành công',
    createBookingSuccessfully: 'Đặt phòng thành công',
    createDataSuccessfully: 'Thêm thành công',
    updateSuccess: 'Cập nhật thành công',
    createSuccess: 'Tạo thành công',
    deleteSuccess: 'Xóa thành công',
    receiveSuccess: 'Tiếp nhận thành công',
    refuseSuccess: 'Từ chối thành công',
    completeSuccess: 'Cập nhật thành công',
    addSuccess: 'Thêm thành công',
    insertSuccess: 'Thêm thành công',
    updateSuccessful: 'Sửa thành công',
    deleteSuccessful: 'Xóa thành công',
    downloadSuccessful: 'Đã tải file thành công',
    createCodeSuccessfully: 'Thêm thành công',
    editMarketSegSuccess: 'Cập nhật thành công',
    editMarketSegGroupSuccess: 'Cập nhật thành công',
    updateSourceSuccess: 'Cập nhật thành công',
    addSourceSuccess: 'Thêm thành công',
    addBuildingSuccess: 'Thêm thành công',
    updateBuildingInformationSuccess: 'Cập nhật thành công',
    delete1Building: 'Xóa thành công',
    deleted1RoomProperty: 'Xóa thành công',
    deleted1RoomLevel: 'Xóa thành công',
    addRoomSuccess: 'Tạo thành công',
    updateRoomInformationSuccess: 'Cập nhật thành công',
    deleted1Room: 'Xóa phòng thành công',
    deleteCodeSuccessfully: 'Xóa thành công',
    updateCodeSuccessfully: 'Cập nhật thành công',
    deleteSourceGroupSuccess: 'Xóa thành công',
    Deleted1GuestNoteTemplate: 'Xóa thành công',
    createAttributeCategorySuccessful: 'Thêm thành công',
    updateAttributeCategorySuccessful: 'Cập nhật thành công',
    deleteAttributeCategorySuccessful: 'Xóa thành công',
    addSubTransactionSuccess: 'Thêm thành công',
    updateSubTransactionSuccess: 'Cập nhật thành công',
    deleted1SubTransaction: 'Xóa thành công',
    createEarlyLateCheckSuccessful: 'Thêm cấu hình thành công',
    updateEarlyLateCheckSuccessful: 'Cập nhật cấu hình thành công',
    addCancelOrNoshowSuccess: 'Thêm cấu hình thành công',
    updateCancelOrNoshowSuccess: 'Cập nhật cấu hình thành công',
    deleteCancelOrNoshowSuccess: 'Xóa cấu hình thành công',
    createPackageCategorySuccess: 'Tạo danh mục gói thành công',
    updatePackageCategorySuccess: 'Cập nhật danh mục gói thành công',
    deletePackageCategorySuccess: 'Xóa danh mục gói thành công',
    addedNewBreakfastCodeSuccessfully: 'Thêm mã ăn sáng thành công',
    updatedNewBreakfastCodeSuccessfully: 'Cập nhật mã ăn sáng thành công',
    deletedBreakfastCodeSuccessfully: 'Xóa mã ăn sáng thành công',
    editPriceDailySuccess: 'Cập nhật thành công',
    editSuccess: 'Cập nhật thành công',
    addPriceTypePeriodSuccess: 'Thêm thành công',
    updateProductFail: 'Cập nhật thành công',
    deleted1Transaction: 'Xóa thành công',
    addPriceByLevelSuccess: 'Thêm mã giai đoạn thành công',
    editPriceByLevelSuccess: 'Sửa mã giai đoạn thành công',
    editPriceCategorySuccess: 'Cập nhật danh mục giá thành công',
    editPriceByPeriodSuccess: 'Cập nhật giá giai đoạn thành công',
    createAccountSuccessfully: 'Tạo thành công',
    addRoomChargeSuccess: 'Tạo thành công',
    cancelSuccess: 'Hủy thành công',
    transferSuccess: 'Chuyển giao dịch thành công',
    splitSuccess: 'Theo tác thành công',
    deletedPackageGroupSuccessfully: 'Xóa nhóm gói thành công',
    deletePackageSuccessfully: 'Xóa gói thành công',
    deletePackageDetailSuccessfully: 'Xóa chi tiết gói thành công',
    updateTransactionSuccess: 'Cập nhật thành công',
    assignSuccessful: 'Gán phòng thành công',
    addRoomSurchargeSuccess: 'Thêm phụ thu phòng thành công',
    updateRoomSurchargeSuccess: 'Cập nhật phụ thu phòng thành công',
    deleteRoomSurchargeSuccess: 'Xóa phụ thu phòng thành công',
    editPriceRoomLevelSuccess: 'Cập nhật giá hạng phòng thành công',
    updateValueSuccess: 'Cập nhật thông tin thành công',
    editPriceTypePeriodSuccess: 'Sửa thông tin giá theo giao đoạn thành công',
    createSuccessful: 'Thêm thành công',
    updateWarehouseSuccessful: 'Cập nhật thành công',
    addPromotionSuccess: 'Thêm khuyến mại thành công',
    editPromotionSuccess: 'Sửa khuyến mại thành công',
    deletePromotionSuccess: 'Xóa khuyến mại thành công',
    updatePromotionNewSuccessfully: 'Cập nhật khuyến mại thành công',
    deletePromotionNewSuccess: 'Xóa khuyến mại thành công',
    createPromotionNewSuccessfully: 'Thêm khuyến mại thành công',
    updateVoucherSuccessfully: 'Cập nhật voucher thành công',
    deleteVoucherSuccess: 'Xóa voucher thành công',
    createVoucherSuccessfully: 'Thêm voucher thành công',
    assignAccountFunctionSuccessfully: 'Phân quyền người dùng thành công',
    submitBreakfastSuccess: 'Cập nhật bữa sáng thành công',
    deleteLostItemSuccess: 'Xóa thành công',
    addLostItemSuccess: 'Thêm thành công',
    editLostItemSuccess: 'Cập nhật thành công',
    createDebitAccountSuccessfully: 'Tạo thành công',
    deleteAccountsSuccessfully: 'Xóa thành công',
    updateDebitAccountSuccessfully: 'Cập nhật thành công',
    createInvoiceSuccess: 'Chuyển công nợ thành công',
    handleSuccess: 'Thao tác thành công',
    createMissionSuccessfully: 'Tạo thành công',
    deleted2RoomLevel: 'Xóa hạng phòng thành công',
    theNumberOfRoomsExceedsTheNumberOfRoomsOfTheCreatedRoomLevel:
      'Số lượng phòng vượt quá số lượng phòng của hạng phòng đã được tạo',
    'addOOS/OOOSuccess': 'Gán trạng thái phòng thành công',
    updateOOSOOOSuccessful: 'Cập nhật trạng thái OOO/OOS thành công',
    deleteOOSOOOSuccessful: 'Xóa OOO/OOS thành công',
    addRoomServiceSuccess: 'Thêm nhóm dịch vụ buồng phòng thành công',
    updateRoomServiceSuccess: 'Thêm nhóm dịch vụ buồng phòng thành công',
    deleteRoomServiceGroup: 'Xóa nhóm dịch vụ buồng phòng thành công',
    updateMissionSuccessfully: 'Cập nhật thành công',
    cancelCheckoutSuccess: 'Hủy trả phòng thành công',
    checkoutSuccess: 'Trả phòng thành công',
    cancelApplySuccess: 'Thao tác thành công',
    applySuccess: 'Thao tác thành công',
    addMarketSegGroupSuccess: 'Tạo thành công',
    addMarketSegSuccess: 'Tạo thành công',
    updateAccountSuccessfully: 'Cập nhật thành công',
    importProductExcelFileSuccess: 'Tải lên thành công',
    firstNameNo: 'Tên không được để trông',
    onlyOneTravellerMaster: 'Chỉ tối đa 01 khách chính',
    mustHaveOneTravellerMaster: 'Cần có khách chính',
    arriveDateSmallerThanDepartDate: 'Ngày đến nhỏ hơn ngày đi',
    numOfNightInvalid: 'Số đêm không hợp lệ',
    onlyOneDiscountFee: 'Chỉ 01 hình thức giảm giá',
    notEnoughNumOfRoom: 'Không đủ số lượng phòng',
    specialServiceIdNotNull: 'Mã dịch vụ đặc biệt không được để trống',
    serviceStartDateNotNull: 'Ngày bắt đầu sử dụng dịch vụ không được để trống',
    serviceEndDateNotNull: 'Ngày kết thúc sử dụng dịch vụ không được để trống',
    quantityMinValue1: 'Số lượng tối thiểu là 01',
    childNumMinValue0: 'Số lượng trẻ em tối thiểu là 0',
    u5ChildNumMinValue0: 'Số lượng trẻ em dưới 05 tuổi tối thiểu là 0',
    roomTypeIdNotNull: 'Hạng phòng không được để trống',
    arriveDateNotNull: 'Ngày đến không được để trống',
    departDateNotNull: 'Ngày đi không được để trống',
    numOfRoomMinValue1: 'Số lượng phòng tối thiểu là 01',
    numOfRoomMaxValue50: 'Số lượng phòng tối đa là 50',
    numOfGuestMinValue1: 'Số lượng khách tối thiểu là 01',
    numOfNightMinValue1: 'Số đêm tối thiểu là 01',
    priceMustGreaterThan0: 'Giá phải lớn hơn 0',
    currencyIdMustNotNull: ' không được để trống',
    sourceNotNull: 'Nguồn không được để trống',
    bookingStatusNotNull: 'Trạng thái đặt phòng không được để trống',
    updateRoomBookingSuccess: 'Đã cập nhật phòng',
    insertSuccessfully: 'Tạo thành công',
    deleteBusinessDistrictsSuccessfully: 'Xóa thành công',
    'Update business district successfully': 'Cập nhật thành công',
    getDebitAccountSuccess: 'Đã cập nhật danh sách tài khoản công nợ',
    addRoomServiceGroupSuccess: 'Thêm nhóm dịch vụ buồng phòng thành công',
    undoneSuccess: 'Hoàn tác thành công',
    deletedSubTransactionSuccess: 'Xoá thành công',
    InsertSuccess: 'Thêm thành công',
    addSuccessfully: 'Thêm thành công',
    updateBookingGroupSuccessfully: 'Thay đổi đoàn thành công',
    updateChildBookingGroupSuccessfully: 'Cập nhật đoàn phụ thành công',
    checkInSuccessfully: 'Check in thành công',

    // datnt
    createAgentSuccessfully: 'Thêm thành công',
    updateCustomerSuccessfully: 'Cập nhật thành công',
    mergeProfileSuccessfully: 'Gộp thành công',
    deleteAgentsSuccessfully: 'Xóa thành công',
    insertDataSuccessfully: 'Thêm dữ liệu thành công',
    // createInvoiceCompanySuccessfully: 'Tạo thành công',
    updateInvoiceCompanySuccessfully: 'Sửa thành công',
    deleteInvoiceCompaniesSuccessfully: 'Xóa thành công',
    success: 'Thành công',
    paymentSuccess: 'Thanh toán thành công',
    depositSuccessfully: 'Nạp tiền thành công',
    updateNoteSuccessfully: 'Cập nhật ghi chú thành công'
  },
  infoMsg: {
    clickUpdateForSaving: 'Click vào Cập nhật để lưu',
    enterSearchInformation: 'Nhập thông tin tìm kiếm',
    searchByCode: 'Tìm kiếm theo mã'
  },
  validation: {
    required: 'Trường "{field}" không được để trống',
    email: 'Vui lòng nhập e-mail đúng định dạng',
    minLength: 'Trường {field} cần có độ dài tối thiểu {length} kí tự',
    maxLength: 'Trường {field} chỉ có độ dài tối đa {length} kí tự',
    betweenLength:
      'Trường {field} cần có độ dài từ {minLength} đến {maxLength} kí tự',
    dateIsAfter: 'Trường "{afterDate}" không được sớm hơn trường "{date}"',
    number: 'Trường {field} phải là số hợp lệ'
  }
}
